import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { CategoryInspirationListResource } from 'app/models/CategoryInspirationListResource';
import { UtilsService } from 'app/services/utils.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vbn-categories-list',
  templateUrl: './categories-list.component.html',
  styleUrls: ['./categories-list.component.scss']
})
export class CategoriesListComponent implements OnInit {

  errorMessage: any;
  categories: CategoryInspirationListResource;
  dateNow: Date;

  constructor(private service: UtilsService, private router: Router, private _notificationService: NotificationsService,
    private translate: TranslateService,) {
    this.categories = new CategoryInspirationListResource();
    this.dateNow = new Date();
   }

  ngOnInit() {
    this.getCategoriesList();
  }

  getCategoriesList() {
    this.service.get('/admin/newsCategory/getAllCategories')
      .subscribe(
        response => {
         this.categories = response;
        },
        error => this.errorMessage = <any>error);
  }

  edit(rid) {
    this.router.navigate(['/edit-category/' + btoa('{ "categoryRid" : "' + rid + '"}')]);
  }

  delete(rid) {
    this.service.get('/admin/newsCategory/deleteCategory/' + rid)
      .subscribe(
        response => {
          forkJoin(
            this.translate.get('Success'),
            this.translate.get('Category was deleted!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.getCategoriesList();
        },
        error => this.errorMessage = <any>error);
  }
}
